var _excluded = ["children"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import React, { useMemo, createContext, useContext } from 'react';
import qs from 'qs';
import { useMessage } from "./useMessage";
export var createFetch = function createFetch(option, message) {
  var _ref = option || {},
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 1000 * 60 : _ref$timeout,
    interceptors = _ref.interceptors;
  var client = axios.create({
    timeout: timeout,
    paramsSerializer: function paramsSerializer(params) {
      return qs.stringify(params, {
        allowDots: true,
        arrayFormat: 'indices'
      });
    }
  });
  if (interceptors) {
    var _interceptors$request = interceptors.request,
      _request = _interceptors$request === void 0 ? [] : _interceptors$request,
      _interceptors$respons = interceptors.response,
      response = _interceptors$respons === void 0 ? [] : _interceptors$respons;
    _request.forEach(function (item) {
      client.interceptors.request.use(item);
    });
    response.forEach(function (item) {
      client.interceptors.response.use(item);
    });
  }
  var request = function request(_request2) {
    var url = _request2.url,
      method = _request2.method,
      query = _request2.query,
      data = _request2.data,
      successTip = _request2.successTip,
      errorTip = _request2.errorTip;
    var abort = new AbortController();
    var promise = client.request({
      url: url,
      method: method,
      params: query,
      data: data,
      signal: abort.signal
    }).then(function (data) {
      // console.log('data', data)
      var response = data.data;
      response.$response = data;
      if (successTip) {
        message.success(successTip === true ? '操作成功' : successTip);
      }
      return response;
    }).catch(function (error) {
      var _error$response, _error$response2;
      // console.log('error', error)
      var response = {
        code: ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) || -9999,
        data: (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data,
        msg: error.message || '请求失败',
        $response: error.response
      };
      if (errorTip) {
        message.error(errorTip === true ? '操作失败' : errorTip);
      }
      return response;
    });
    promise.abort = function (reason) {
      try {
        abort.abort(reason);
      } catch (e) {}
    };
    return promise;
  };
  return {
    fetch: request,
    instance: client,
    get: function get(params) {
      return request(_objectSpread(_objectSpread({}, params), {}, {
        method: 'GET'
      }));
    },
    post: function post(params) {
      return request(_objectSpread(_objectSpread({}, params), {}, {
        method: 'POST'
      }));
    },
    put: function put(params) {
      return request(_objectSpread(_objectSpread({}, params), {}, {
        method: 'PUT'
      }));
    },
    del: function del(params) {
      return request(_objectSpread(_objectSpread({}, params), {}, {
        method: 'DELETE'
      }));
    },
    patch: function patch(params) {
      return request(_objectSpread(_objectSpread({}, params), {}, {
        method: 'PATCH'
      }));
    }
  };
};
export var FetchContext = /*#__PURE__*/createContext(undefined);
export var FetchProvider = function FetchProvider(props) {
  var _props$interceptors, _props$interceptors2;
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var message = useMessage();
  var fetch = useMemo(function () {
    return createFetch(rest, message);
  }, [props.timeout, (_props$interceptors = props.interceptors) === null || _props$interceptors === void 0 ? void 0 : _props$interceptors.request, (_props$interceptors2 = props.interceptors) === null || _props$interceptors2 === void 0 ? void 0 : _props$interceptors2.response]);
  return /*#__PURE__*/React.createElement(FetchContext.Provider, {
    value: fetch
  }, children);
};
export var useFetch = function useFetch() {
  return useContext(FetchContext);
};